import { explanationVideos } from "config/explanation-videos"
import { getEnvironment } from "config/environment"
import { IJourneyPage } from "config/journeys"
import * as React from "react"
import * as styles from "./styles.module.scss"
import BillionFundedLoans from "../../BillionFundedLoans"
import JourneyDetails from "../JourneyDetails"
import JourneyHero from "../../JourneyHero"
import LetsTalk from "../../LetsTalk"
import PriceGuaranteedJourney from "../../PriceGuaranteedJourney"
import RateCalculator from "../RateCalculator"
import VideoLarge from "../../VideoLarge"
import { Person } from "../../LetsTalk/person"

export interface JourneyPageProps {
  journey: IJourneyPage
  continueUrl: string
  transactionType: string
}

const JourneyPage: React.FC<JourneyPageProps> = ({
  continueUrl,
  journey,
  transactionType,
}) => {
  const letsTalkButton = {
    text: "Book a free call",
    url: "https://charlie-better.youcanbook.me/",
  }

  return (
    <div className={styles.journey}>
      <JourneyHero journey={journey} continueUrl={continueUrl} />

      {journey.bstVideo && (
        <VideoLarge
          id={explanationVideos[journey.bstVideo.id].id}
          title={explanationVideos[journey.bstVideo.id].title}
          isTitleSizeLarge={true}
          src={explanationVideos[journey.bstVideo.id].directSourceUrl}
          poster={explanationVideos[journey.bstVideo.id].poster}
        />
      )}
      <JourneyDetails details={journey.details} />
      <PriceGuaranteedJourney>
        <RateCalculator transactionType={transactionType} />
      </PriceGuaranteedJourney>
      <BillionFundedLoans />

      <LetsTalk
        heading={`Hi, I'm Elizabeth`}
        subhead={`I'm a Mortgage Expert at Better. My team is here to help make getting a mortgage easy. We're available on your schedule over text, email, or phone. Let's talk.`}
        button={letsTalkButton}
        name={Person.Elizabeth}
        nmlsCode="1658188"
      />
    </div>
  )
}

export default JourneyPage
